import script from "./centralkitchenDepartments.vue?vue&type=script&setup=true&lang=js"
export * from "./centralkitchenDepartments.vue?vue&type=script&setup=true&lang=js"

import "./centralkitchenDepartments.vue?vue&type=style&index=0&id=7d4ac0ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4ac0ae"]])

export default __exports__